import { cn } from '@/lib/cn';

interface FilterButtonProps {
  children: React.ReactNode;
  isSelected: boolean;
  onClick: () => void;
}

export function FilterButton({
  children,
  isSelected,
  onClick,
}: FilterButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'hover:bg-secondary/85 hover:text-secondary-foreground rounded-md bg-[#eee] px-5 py-2.5 whitespace-nowrap transition-all',
        isSelected
          ? 'bg-secondary text-secondary-foreground hover:bg-secondary'
          : '',
      )}
    >
      {children}
    </button>
  );
}
